import { ESTADO_CIVIL_OBJ as ESTADO_CIVIL } from "../constants/estadosCivil"

export function estadoCivilFilter (value) {
  return ESTADO_CIVIL[value] || 'Não informado.'
}
